import { ITableContractModel, ITableContractModelMeta, TableContractModelMeta } from '../interfaces/tableContractModel';
import { BrandType } from '../enums/brandType';
import { PhaseContract } from '../enums/phaseContract.enum';
import { TypeContract } from '../enums/typeContract.enum';
import { TypeRequest } from '../enums/typeRequest.enum';

export class TableContractModel implements ITableContractModel {
    id: number;
    brand: BrandType;
    createdAt: Date;
    customerFullName: string;
    phase: PhaseContract;
    agencyFullName: string;
    agentFullName: string;
    contractType: TypeContract;
    requestType: TypeRequest;
    city: string;
    podNumber: number;
    pdrNumber: number;
    meta: ITableContractModelMeta;

    constructor(tcm: ITableContractModel) {
        this.id = tcm.id;
        this.brand = tcm.brand;
        this.createdAt = tcm.createdAt != null ? new Date(tcm.createdAt) : null;
        this.customerFullName = tcm.customerFullName;
        this.phase = tcm.phase;
        this.agencyFullName = tcm.agencyFullName;
        this.agentFullName = tcm.agentFullName;
        this.contractType = tcm.contractType;
        this.requestType = tcm.requestType;
        this.city = tcm.city;
        this.podNumber = tcm.podNumber;
        this.pdrNumber = tcm.pdrNumber;
        this.meta = new TableContractModelMeta(tcm.meta);
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/tableContractModel.ts